import React from "react";

function ActiveFinanceIcon({fill}) {
  return (
    <>
      <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M7.12514 8.6653C7.23918 8.5995 7.33387 8.5048 7.3997 8.3907C7.46553 8.2767 7.50017 8.1473 7.50014 8.0156V1.26562C7.49947 1.14605 7.47022 1.02837 7.41483 0.9224C7.35944 0.81643 7.27951 0.72523 7.18171 0.65643C7.08392 0.58762 6.97109 0.5432 6.85263 0.52686C6.73418 0.51052 6.61353 0.52274 6.50076 0.5625C4.31168 1.33726 2.47075 2.86748 1.3089 4.87807C0.147064 6.88865 -0.259496 9.2477 0.162324 11.5312C0.184194 11.6493 0.234094 11.7604 0.307834 11.8552C0.381574 11.95 0.476994 12.0257 0.586074 12.0759C0.684384 12.1219 0.791624 12.1456 0.900144 12.1453C1.03177 12.1454 1.16111 12.1108 1.27514 12.045L7.12514 8.6653ZM6.00014 2.40187V7.5825L1.51139 10.1728C1.50014 10.0312 1.50014 9.8887 1.50014 9.75C1.50147 8.2297 1.92229 6.73928 2.71626 5.44279C3.51023 4.1463 4.64656 3.09404 6.00014 2.40187ZM19.5001 9.75C19.5009 11.8904 18.7973 13.9716 17.4978 15.6725C16.1984 17.3733 14.3754 18.5993 12.31 19.1613C10.2447 19.7233 8.0518 19.59 6.06973 18.7821C4.08765 17.9741 2.42652 16.5363 1.34264 14.6906C1.29211 14.6054 1.25898 14.5109 1.24516 14.4128C1.23134 14.3147 1.23711 14.2148 1.26213 14.1189C1.28715 14.023 1.33092 13.933 1.39092 13.8541C1.45092 13.7753 1.52596 13.7091 1.6117 13.6594L9.0001 9.3591V0.75C9.0001 0.55109 9.0792 0.36032 9.2198 0.21967C9.3605 0.0790201 9.5512 0 9.7501 0C11.4516 0.00087 13.1232 0.44675 14.599 1.29338C16.0749 2.14001 17.3036 3.35794 18.1633 4.82625C18.1736 4.84125 18.183 4.85625 18.1923 4.87219C18.2017 4.88812 18.2111 4.90687 18.2195 4.92375C19.0608 6.39297 19.5023 8.057 19.5001 9.75Z"
          fill={fill}
        />
      </svg>
    </>
  );
}

export default ActiveFinanceIcon;
